import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function DeleteWebsite({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Delete Website'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

